import React, { Component } from 'react';
import { getCbSession } from 'legacy/src/components/auth/utils';
import { isOnLogout } from 'legacy-src/utility/UrlPaths';
import { clearLocalStorage } from 'legacy-packages/ft-cb';
import { isLockdownBrowser } from './utils';
import {
  emptyImpersonaterLocalStorage,
  isImpersonating,
} from 'legacy/src/components/impersonating/utils';
import clearPersistedFilters from 'chameleon-src/components/questionBank/hooks/usePersistFilters/clearPersistedFilters';
import LOGOUT_WHITELIST from 'chameleon/ui-stack/constants/lc-logout-whitelist';

/*
 * Identity Widget 5.1.0
 * Includes Levity as a dependency
 * */
export class IdentityWidget extends Component {
  constructor(props) {
    super(props);
    this.identityHook = null;
  }

  render() {
    return (
      <div className="form_account_container">
        <div className="contents">
          <div id="ft-levity-login" ref={(elm) => (this.identityHook = elm)} />
        </div>
      </div>
    );
  }
}

export function bindLevityEvents() {
  if (OVERRIDE_SSO_LOGIN) {
    // eslint-disable-next-line no-console
    console.info('SSO Override is enabled');
    return;
  }
  this.props.bindLevityEventsAction();
  const token = window.localStorage.getItem('account_access_token');
  /**
   * Get data about levity session, and bind handlers to Login/Logout events
   */
  const cbSession = getCbSession();
  const cbObject = (window.cb && window.cb.core && window.cb.core.iam) || {};

  /**
   * Lev says to extend timeout before trying to do a redirect or logout on our page
   * to allow levity script to do a second fetch for bsauth. This will suspend logout event from completing
   * even though levity fires logout event
   */
  if (cbObject.getEventBus) {
    cbObject
      .getEventBus()
      .on(cbObject.events.Logout, () => levityLogout(this.props));
    cbObject
      .getEventBus()
      .on(cbObject.events.Login, () => levityLogin(this.props));
  }

  /**
   * If user navigates back to fym from another service (e.g. units, am) after cbSession expiry, log user out.
   */
  if (
    cbSession.isLoggedIn === false &&
    token &&
    !isOnLogout(this.props.location.pathname)
  ) {
    levityLogout(this.props);
  }
}
/**
 * Listen for login event from Levity and auto-login a user if not already signed in
 */
export function levityLogin(props) {
  const cbSession = getCbSession();
  const tokenSessionId = window.localStorage.getItem('cb_session_id');
  props.levityLoginAction(props);
  /**
   * There are two scenarios where you need a levity login
   * 1. There is an active sesion on CB, and you don't have a token.
   * 2. You have an active session on CB, and you have a token, but the id on CB session
   *    differs from our session. In this case relogin user. This can happen if you logout from ROS without
   *    having an open tab with APC and then log in again on ROS.
   *    Levity just doesn't fires logout, and you are hanging with old user.
   */
  if (
    cbSession.sessionId !== 'not_logged_in' &&
    cbSession.sessionId &&
    tokenSessionId
  ) {
    if (cbSession.sessionId !== tokenSessionId) {
      clearLocalStorage(LOGOUT_WHITELIST);
    }
  }
}

/**
 * Listen for a logout event and auto-logout a user if they were signed in via SSO
 */
function levityLogout(props) {
  if (isLockdownBrowser()) return; // prevent SSO logout if the user is in a secure browser
  props.levityLogoutAction(props);
  const token = window.localStorage.getItem('account_access_token');
  // sometimes window.current_user was empty for pre-ap test user's direct login
  // logout the case that user and token exists and user's login is SSO (test users are not SSO)
  const user = props.userData.me || window.current_user;
  const impersonating = isImpersonating();

  if (token && user && !impersonating) {
    clearPersistedFilters(user.initId);
  }

  if (token && user && (user.ssoLogin !== 'Not SSO' || impersonating)) {
    emptyImpersonaterLocalStorage();
    window.location.href = `${FYM_FRONTEND_URL}/logout?next=${props.location.pathname}`;
  }
}
